<template lang="html">
  <div class="center-content">
    <!-- <h3>个人信息</h3> -->
    <CenterItem v-if="getCenterAuth.editInfo" title="个性签名" @click="judgeUserInfo" class="avater-item">
      <template v-slot:left>
        <div class="center-item-left">
          <div class="avatar">
            <!-- <img class="avatars" :src="`${getUserAvater}?x-oss-process=image/resize,m_fill,w_128,h_128`" alt=""> -->
            <van-image
              width='64px'
              height='64px'
              fit="cover"
              round
              class="avater"
              :src="`${getUserAvater}?x-oss-process=image/resize,m_fill,w_128,h_128`" alt="">
            >
              <template v-slot:error>{{ getErrorName(getUserNickName) }}</template>
            </van-image>
            <!-- <input type="file" class="input"> -->
            <!-- <img class="avatars" v-if="!getUserAvater" src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/default-profile.png" alt="">
            <img v-else class="avatars" :src="`${getUserAvater}?x-oss-process=image/resize,m_fill,w_128,h_128`" alt=""> -->
          </div>
          <!-- <div class="right null" v-if="Object.is(getUserAvater, 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/user/defaultProfile.png') || Object.is(getUserNickName, '请补充昵称')">
创建头像和昵称
          </div> -->
          <div class="right">
            <div class="nickName">{{getUserNickName}}</div>
            <div class="desc">编辑个人信息</div>
          </div>
        </div>
      </template>
    </CenterItem>
    <CenterItem v-if="getCenterAuth.published"  title="已发表内容" @click="goRouter('/published')" style="margin-top: 12px;"/>
    <CenterItem v-if="getCenterAuth.messageRecode" title="消息" @click="goRouter('/messageRecode')">
      <template v-slot:left>
        <div class="left">
          <span>消息</span>
          <span v-if="getNewMessageCount" class="count">{{getNewMessageCount}}</span>
        </div>
      </template>
    </CenterItem>
    <CenterItem v-if="getCenterAuth.summoningOrder" title="我的召集令" @click="goRouter('/summoningOrder')" style="margin-top: 12px;"/>
    <CenterItem title="我的问卷" @click="goRouter('/questionnaireList')" />
    <!-- <CenterItem v-if="getCenterAuth.collection"  title="我的收藏" @click="goRouter('/collection')"/> -->
    <!-- <CenterItem title="奖品记录" @click="goRouter('/prizeRecord')" /> -->
    <!-- <CenterItem v-if="getCenterAuth.refiningRecode"  title="开炼记录" @click="goRouter('/refiningRecode')"/> -->
    <CenterItem v-if="getCenterAuth.feedback"  title="建议反馈" @click="goFeedback()" style="margin-top: 12px;"/>
    <!-- <CenterItem v-if="getCenterAuth.role && isShow"  title="切换角色" @click="goRouter('/role')" style="margin-top: 12px;"/> -->
    <SetNickName :show="showSetNickName" @close="showSetNickName = false"/>
  </div>
</template>

<script>
import { putFile, get as getRequest } from '../../../utils/request'
import { get } from '../../../utils/token'
import { createNamespacedHelpers } from 'vuex'
import CenterItem from '../../../components/centerItem'
import AuthMixis from '../../../minixs/auth'
import { prefix } from '../../../utils/config'
const { mapGetters, mapActions } = createNamespacedHelpers('user')
const { mapActions: mapTabBarActions } = createNamespacedHelpers('tabbar')
const { mapGetters: mapMessageGetters } = createNamespacedHelpers('message')
export default {
  mixins: [AuthMixis],
  components: {
    CenterItem
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.updateTabIndex('center')
    })
  },
  data () {
    return {
      password: '',
      signName: '',
      messageCount: 0,
      isShow: false,
      mobile: get('mobile')
    }
  },
  mounted () {
  },
  created () {
    const user = get('user')
    this.isShow = user.isCheckoutRole
  },
  watch: {
    $route (value) {
      if (Object.is(this.$route.name, 'Center')) {
        this.getMessageCount()
      }
    }
    // getUserAvater (value) {
    //   console.log('watch', value)
    // }
  },
  methods: {
    getErrorName (name) {
      for (let i = 0; i < name.length; i++) {
        const charCode = name.charCodeAt(i)
        if (charCode >= 0x4e00 && charCode <= 0x9fff) {
          return name.charAt(i)
        }
      }
      return name[0]
    },
    judgeUserInfo () {
      const flag = this.judgeUserNickName()
      if (flag) {
        return
      }
      this.goRouter('/bbs/editUserInfo')
    },
    ...mapActions({
      updateUserAvater: 'updateUserAvater',
      updateUserSignName: 'updateUserSignName'
    }),
    ...mapTabBarActions({
      updateTabIndex: 'updateTabIndex'
    }),
    getMessageCount () {
      const user = get('user')
      const promise = getRequest({
        url: `/user/messageCount/${user.id}`
      })
      promise.then(res => {
        const { data: { code, detail } } = res
        if (Object.is(code, 200)) {
          this.messageCount = detail
        }
      }).catch(() => {
      })
    },
    goFeedback () {
      if (!prefix) {
        window.location.href = 'https://jinshuju.net/f/qzWyxR'
      } else {
        window.location.href = 'https://jinshuju.net/f/V2Tbg7'
      }
    },
    goRouter (path) {
      this.$router.push(`/exerland${path}`)
    },
    uploadFile (e) {
      const promise = putFile({
        url: '/bbs/uploadFile',
        file: e.target.files[0]
      })
      promise.then(res => {
        const { status, data: { data } } = res
        if (Object.is(status, 200)) {
          this.avatar = data[0]
          this.updateUserAvater(this.avatar)
        }
      })
    }
  },
  computed: {
    ...mapGetters({
      getUserNickName: 'getUserNickName',
      getUserAvater: 'getUserAvater'
    }),
    ...mapMessageGetters({
      getNewMessageCount: 'getNewMessageCount'
    }),
    getCenterAuth () {
      return this.$store.getters['centerAuth/getAuth']
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.van-image__error {
  font-size: 28px;
}
.center-content {
  background: #F2F2F7;
  height: calc(100vh - 50px);
  overflow-y: scroll;
  h3 {
    text-align: center;
    padding: 9px 0;
    margin-bottom: 16px;
    font-size:17px;
    font-family:SFProText-Semibold,SFProText;
    font-weight:600;
    color:rgba(0,0,0,1);
    line-height:22px;
    border-bottom: 1px solid #E2E2E2;
    background:rgba(242,242,247,1);
  }
  .left {
    display: flex;
    align-items: center;
      .count {
        display: inline-block;
        width: 18px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        border-radius: 50%;
        background:rgba(24,204,159,1);
        color: #fff;
        font-size: 11px;
        margin-left: 12px;
      }
    }
  .avater-item {
    .center-item-right {
      height:64px;
    }
    .center-item-left {
      display: flex;
      align-items: center;
      .right {
        margin-left: 16px;
        .nickName {
          font-size:17px;
          font-family:PingFangSC-Medium,PingFang SC;
          font-weight:500;
          color:rgba(51,51,51,1);
          line-height:24px;
          margin-bottom: 8px;
        }
        .desc {
          font-size:13px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(136,136,136,1);
          line-height:18px;
        }
      }
      .null {
        font-size:17px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:24px;
        margin-left: 40px;
      }
    }
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 6.4%;
      width: 87.6vw;
      height: 2px;
      background: #fff;
      z-index: 9;
    }
  }
}

</style>
